var _rect, _path, _path2, _path3;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgHisViewDocument = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 20,
    height: 20,
    rx: 3,
    fill: "#F6F7F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6637 5H13.7804C14.8249 5 15.3472 5 15.6717 5.32451C15.9962 5.64901 15.9962 6.1713 15.9962 7.21588V7.3325M13.6637 14.33H13.7804C14.8249 14.33 15.3472 14.33 15.6717 14.0055C15.9962 13.681 15.9962 13.1587 15.9962 12.1141V11.9975M7.8325 5H7.71587C6.6713 5 6.14901 5 5.82451 5.32451C5.5 5.64901 5.5 6.1713 5.5 7.21588V7.3325M7.8325 14.33H7.71587C6.6713 14.33 6.14901 14.33 5.82451 14.0055C5.5 13.681 5.5 13.1587 5.5 12.1141V11.9975",
    stroke: "#3C3ADA",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7482 10.2483C11.0702 10.2483 11.3313 9.98721 11.3313 9.66516C11.3313 9.34311 11.0702 9.08203 10.7482 9.08203C10.4261 9.08203 10.165 9.34311 10.165 9.66516C10.165 9.98721 10.4261 10.2483 10.7482 10.2483Z",
    stroke: "#3C3ADA",
    strokeWidth: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3791 9.30188C14.4541 9.4497 14.4916 9.52358 14.4916 9.66312C14.4916 9.80267 14.4541 9.87655 14.3791 10.0244C14.0138 10.7438 12.9711 12.2872 10.7483 12.2872C8.52539 12.2872 7.48272 10.7438 7.11743 10.0244C7.0424 9.87655 7.00488 9.80267 7.00488 9.66312C7.00488 9.52358 7.0424 9.4497 7.11743 9.30188C7.48272 8.58242 8.52539 7.03906 10.7483 7.03906C12.9711 7.03906 14.0138 8.58242 14.3791 9.30188Z",
    stroke: "#3C3ADA",
    strokeWidth: 0.8
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHisViewDocument, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/HIS_View_Document.f16cb3cd.svg";
export { ForwardRef as ReactComponent };